import CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy from './CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy'

export default function CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy() {}

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype = new CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy();

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype.init = function({timeFormat, showOthers}) {
    CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.init.call(
        this,
        {
            timeFormat: timeFormat,
            showAverageRates: false,
            showOthers: showOthers,
        }
    )
    return this
}

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype.getLevelNameKey = function ()
{
    return "user.group";
};

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype.getLevelCellsClassName = function ()
{
    return "darkGreenHeaderCell userGroup";
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.js